module.exports = /* @ngInject */
(
    ApiConfig,
    AnthroConfig,
    SecureInterceptorService
) => {
    return {
        sendEmail(request) {
            const entity = {
                document: {
                    service: 'ebmtrigger1',
                    cookie: 'test',
                    request
                }
            };
            const queryParams = {
                brand: AnthroConfig.sterlingBrandCodes[AnthroConfig.siteId],
                emailtype: 'MANUAL_EMAIL'
            };

            return SecureInterceptorService.post({
                entity,
                queryParams,
                url: ApiConfig.email
            });
        }
    };
};
